import { ConsultationExport } from "~/providers/utils/types/consultation";
import { PdfDocument } from "../shared/PdfDocument";
import { getPatientNameAndAge } from "../utils";
import { ConsultationExportReport } from "./ConsultationExportReport";
import { ConsultationExportSummary } from "./ConsultationExportSummary";

export const ConsultationExportDocument = ({
  data,
}: {
  data: ConsultationExport;
}) => (
  <PdfDocument
    documentTitle="Consultation report (H&P)"
    headerTitle={`Consultation report for ${getPatientNameAndAge(data)}`}
  >
    <ConsultationExportReport data={data} />
    <ConsultationExportSummary data={data} />
  </PdfDocument>
);
